import { render } from "./Skills.vue?vue&type=template&id=bb5e5e0e"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"
script.render = render

export default script